import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

export default class FinesseLogo extends HTMLElement {
  page: string = this.getAttribute('page') || 'index'
  ratio: number = parseFloat(this.getAttribute('data-ratio') || '1')

  announcement: HTMLElement | null = null
  logo: HTMLElement | null = null
  headerLists: NodeListOf<HTMLElement> | null = null

  indexStyles = `fixed flex justify-center px-6 mobile:!px-4 py-4 flex top-0 left-0 w-full z-10 bg-white duration-0 pointer-events-none`

  constructor() {
    super()

    // is there an announcement bar? TODO: add extra top space
    window?.addEventListener('announcement:toggle', this.handleAnnouncement.bind(this) as EventListener)

    this.headerLists = document.querySelectorAll('ul[data-header-list]')

    this.announcement = document.querySelector('finesse-announcement-bar')

    document.body.style.marginTop = '52px'

    if (this.page !== 'index' || window.innerWidth < 769) {
      this.headerLists?.forEach((list) => {
        list.classList.remove('opacity-0')
      })

      return
    }

    gsap.registerPlugin(ScrollTrigger)

    this.logo = this.querySelector<HTMLElement>('a[data-logo]') as HTMLElement

    // add margin to body to allow room for logo animation
    const height = window.innerWidth / this.ratio + (window.innerWidth < 769 ? 16 : 20) + (this.announcement ? (window.innerWidth < 769 ? 64 : 40) : 1)
    document.body.style.marginTop = `${height}px`

    this.style.transition = `background-color 0.5s`

    const timeline = gsap.timeline({
      scrollTrigger: {
        trigger: this.logo,
        start: `0px`,
        end: height,
        scrub: true,
        onLeave: () => {
          this.classList.add('!bg-[rgba(255,255,255,0)]')

          this.headerLists?.forEach((list) => {
            list.classList.remove('opacity-0')
          })

          this.classList.remove('z-10')
        },
        onEnterBack: () => {
          this.classList.remove('!bg-[rgba(255,255,255,0)]')

          this.headerLists?.forEach((list) => {
            list.classList.add('opacity-0')
          })

          this.classList.add('z-10')
        }
      },
    })

    timeline.to(this.logo, {
      height: window.innerWidth < 769 ? 26 : 26,
    })
  }

  handleAnnouncement(event: CustomEvent) {
    const isMobile = window.innerWidth < 769
    const isIndex = this.page === 'index'
    const ratioHeight = window.innerWidth / this.ratio + 20
    
    const hasAnnouncement = event.detail.active
    const announcementHeight = event.detail.height - 2
    const height = hasAnnouncement ? announcementHeight + 52 : 52

    const marginTop = isIndex && !isMobile ? (ratioHeight + (hasAnnouncement ? announcementHeight : 1)) : height

    // Update margin top to account for announcement bar
    document.body.style.marginTop = `${marginTop}px`

    // Update logo position to account for announcement bar if on index page
    if (hasAnnouncement && this.page === 'index' && window.innerWidth > 768) {
      this.style.top = `${announcementHeight}px`
    }
  }

  connectedCallback() {
    if (this.page === 'index' && window.innerWidth > 768) {
      this.className = this.indexStyles
    } else {
      this.className = 'relative'
    }
  }
}

customElements.define('finesse-logo', FinesseLogo)
